import m from "../../geodata/es2015/nigeriaLow";
window.am4geodata_nigeriaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/nigeriaLow.js
// module id = null
// module chunks = 